









import Vue, {PropOptions} from 'vue';
import LabSim from '@/tasks/components/simulations/LabSim.vue';

export default Vue.extend({
  name: 'LabSynthesisOfAlum',
  components: {LabSim},
  inheritAttrs: false,
  props: {
    yieldFactor: {
      type: Number,
      default: 90,
    } as PropOptions<number>,
  },
  computed: {
    labData(): string {
      return JSON.stringify({
        yieldFactor: this.yieldFactor,
      });
    },
  },
});
